import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { useConfig } from "@geome/react-next/lib/hooks/config";
import { SectionWithTitle } from "../sectionWithTitle";
import { PropertiesIcon } from "./iconList";
import { useBEM } from "@geome/react-next/lib/hooks/useBEM";
import { useHasIcons } from "./hooks/useHasIcons";
import { useEnabledProperties } from "./hooks/useEnabledProperties";
export const PropertiesSection = ({ configPath = "", sectionName, countryCode, location, renderTitleIcon, renderNullIfEmpty = false, children, icons, sectionProps, altOnIcons = false, }) => {
    const { translate } = useI18n();
    const { enabled, maxStandaloneIcons } = useConfig(`${configPath}sections.${sectionName}`, false);
    const enabledPropertiesList = useEnabledProperties(location, enabled);
    const hasIcons = useHasIcons(enabledPropertiesList, countryCode, icons);
    const listClassName = useBEM({
        block: "properties",
        element: "list",
        modifiers: {
            "has-icons": hasIcons,
        },
    });
    if (renderNullIfEmpty && enabledPropertiesList.length === 0)
        return null;
    return (_jsxs(SectionWithTitle, { className: `properties properties--${sectionName}`, sectionTokenPath: `${configPath}sections.${sectionName}`, renderIcon: renderTitleIcon, id: sectionName, ...sectionProps, children: [children &&
                children({
                    properties: enabledPropertiesList,
                    maxIcons: maxStandaloneIcons,
                    countryCode: countryCode,
                }), _jsx("div", { className: listClassName, role: "list", children: enabledPropertiesList.map((featureKey) => (_jsxs(Fragment, { children: [hasIcons && icons && (_jsx("div", { role: "presentation", children: _jsx(PropertiesIcon, { countryCode: countryCode, featureKey: featureKey, icons: icons, alt: altOnIcons ? translate(featureKey) : "" }) })), _jsx("span", { role: "listitem", "data-token": featureKey, children: translate(featureKey) })] }, featureKey))) })] }));
};
